import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BatteryLow = createReactComponent("BatteryLow", ["svg", defaultAttributes, [["rect", {
  x: "2",
  y: "7",
  width: "16",
  height: "10",
  rx: "2",
  ry: "2",
  key: "174y1r"
}], ["line", {
  x1: "22",
  x2: "22",
  y1: "11",
  y2: "13",
  key: "13axwy"
}], ["line", {
  x1: "6",
  x2: "6",
  y1: "10",
  y2: "14",
  key: "1mnnv9"
}]]]);
export default BatteryLow;